<ng-container *ngIf="layoutVars || layoutVarsResponse">
  <div class="d-flex justify-content-center">
    <div class="col-md-8 d-flex justify-content-center">
      <img [src]="layoutVars && layoutVars.logoUrl ? layoutVars.logoUrl : './assets/images/logo-aar-blue.svg'"
        class="logo" [height]="layoutVars && layoutVars.logoUrl ? 48 : 40" />
    </div>
  </div>

  <div class="card-container">
    <div class="">
      <div class="card-content" *ngIf="!createdSuccessfuly">
        <div class="">
          <div>
            <h4 class="text-center text-uppercase">FINALIZAR CADASTRO</h4>
            <p class="info-text">Para concluir seu acesso, selecione seus interesses e aceite os termos de uso da plataforma.</p>
          </div>
        </div>
        <div class="mt-2" *ngIf="userInfo">
          <form [formGroup]="form" (submit)="submit()">

            <div class="row-form">
              <mat-form-field class="input-field">
                <i matPrefix class="material-icons">email</i>
                <mat-label>E-MAIL</mat-label>
                <input matInput [value]="userInfo.email" readonly class="input-text readonly-field" />
              </mat-form-field>
            </div>

            <div class="row-form">
              <mat-form-field class="input-field">
                <mat-label>WhatsApp</mat-label>
                <i matPrefix><img style="width: 24px; height: 24px;" src="assets/images/icons/Whatsapp-icon.svg" alt=""></i>
                <input matInput formControlName="whatsappNumber" class="input-text" mask="(00) 00000-0000" [dropSpecialCharacters]="false" />
                <mat-error class="mb-2" *ngIf="form.controls.whatsappNumber.errors && form.controls.whatsappNumber.errors.required">
                  WhatsApp é obrigatório quando você opta por receber promoções
                </mat-error>
              </mat-form-field>
            </div>

            <div class="row-form d-flex flex-column">
              <span class="segment-label">Selecione seu interesse para sempre te mantermos atualizado das novidades!</span>
              <div class="segment-content">
                <div class="" *ngFor="let segment of allSegments">
                  <div class="card text-center segment-card"
                  [ngClass]="{
                    'selected': isSegmentSelected(segment.segment)
                  }"
                    (click)="toggleSegment(segment.segment)">
                    <i class="d-block mx-auto cursor-pointer" [ngClass]="segment.iconClass"></i>
                    <div>{{segment.vehicleLabel}}</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row-form whatsapp-optin">
              <mat-checkbox formControlName="whatsappOptin" (change)="changeWhatsappOptinStatus($event)">
                  <span class="whatsapp-text">Desejo receber promoções e oportunidades via WhatsApp</span>
              </mat-checkbox>
            </div>

            <div class="row-form terms-of-use">
              <mat-checkbox formControlName="acceptTermsOfUse">
                <span class="terms-of-use-text">Li e concordo com os <a style="text-decoration: underline; color: #A7A9AB;" href="https://www.autoarremate.com.br/termos-de-uso-autoarremate/" target="_blank">termos e condições de uso</a> da plataforma.*</span>
              </mat-checkbox>
              <mat-error class="mb-2" *ngIf="
              form.controls.acceptTermsOfUse.errors &&
              form.controls.acceptTermsOfUse.errors.required && form.controls.acceptTermsOfUse.dirty
            ">É obrigatório aceitar os termos de uso</mat-error>

              <div class="mandatory-text">(*) Campos obrigatórios.</div>

              <div class="accepted-terms mb-2">
                Ao clicar em "Acessar", você está ciente de que a {{layoutVars && layoutVars.name ? layoutVars.name : 'Auto Arremate'}} irá coletar e tratar seus dados pessoais
                de acordo com a nossa <a style="text-decoration: underline;" [href]="layoutVars && layoutVars.footerLinkUrl ? layoutVars.footerLinkUrl : 'https://www.autoarremate.com.br/politica-de-privacidade-autoarremate/'" target="_blank" [style.color]="layoutVars && layoutVars.primaryColor ? layoutVars.primaryColor : '#A7A9AB'">Política de Privacidade</a>.
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-md-12 text-center">
                <button class="register-button btn btn-primary btn-block d-flex justify-content-center align-items-center" type="submit">
                  <span>Acessar</span>
                </button>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-12 text-center">
                <button type="button" class="back-button btn btn-block text-primary" (click)="logout()">
                  <span style="color: var(--secondary-button-color);">Voltar</span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</ng-container>